export default [
  'references',
  'reference',
  'einzelnachweise',
  'referencias',
  'références',
  'notes et références',
  '脚注',
  'referenser',
  'bronnen',
  'примечания',
]
